import { render, staticRenderFns } from "./AccessibilityButtons.vue?vue&type=template&id=444f9f22&scoped=true"
import script from "./AccessibilityButtons.vue?vue&type=script&lang=js"
export * from "./AccessibilityButtons.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityButtons.vue?vue&type=style&index=0&id=444f9f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f9f22",
  null
  
)

export default component.exports